import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import { CusFormInput,CusFormLabel, FormSubTitleTooltip} from '../validation/Form-Components';
import appDetailsData from '../data/applicantdetailsdata.json'
import { emailValidator, mobileNoValidator } from '../validation/Validators'
 

const ContactDetails = (props) => {
    const{ seq ,fProps, ...oth} = props;

    return(
    <div>
        {oth.showGreyLine &&
            <div style={{paddingTop: "15px"}}> <hr className="greyPanelLine"/> </div>
        }
            <Field component={FormSubTitleTooltip} 
                id={'fstContactDetails'+seq} name={appDetailsData.formSubTitle.ST1}
                tooltipPosition={'right'} tooltipAchor={'target'} 
                tooltipTitle={appDetailsData.tooltipText.ST1}/>  
          
            <Field component={CusFormLabel} 
                leftLabelId={'lblCC'+seq} leftLabelName={appDetailsData.label.cc}
                id={'cc'+seq} name={'+65 Singapore'}/>
         
            <Field component={CusFormInput} 
                leftLabelId={'lblmno'+seq} leftLabelName={appDetailsData.label.mno} 
                id={'mno'+seq} name={'mno'+seq} placeholder={'Please input'} maxLength={8} 
                disabled={oth.disabled}
                validator={mobileNoValidator} />
         
            <Field component={CusFormInput} 
                leftLabelId={'lblem'+seq} leftLabelName={appDetailsData.label.em} 
                id={'em'+seq} name={'em'+seq} placeholder={'Please input'} maxLength={60} 
                disabled={oth.disabled} validator={emailValidator} />
    </div>)
}

export default ContactDetails